import { connect } from 'react-redux'
import { memoizedSystemMessages } from 'store/selector/message'
import SystemMessages from './SystemMessages'

const mapStateToProps = (state) => ({
  systemMessages: memoizedSystemMessages(state)
})

export default connect(mapStateToProps, null)(SystemMessages)
